import React from "react";
import { Phone } from "lucide-react";
import { FadeUp } from "./Reveal";

const collections = [
    {
        id: "gold",
        title: "Gold — 22K & 18K",
        desc: "Necklaces, chains, bangles, kadas and rings — pure gold for every occasion.",
        img: "https://images.unsplash.com/photo-1570212773364-e30cd076539e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-7",
        h: "h-[420px] md:h-[520px]",
    },
    {
        id: "diamond",
        title: "Diamond",
        desc: "Solitaires and diamond sets — brilliance for your special moments.",
        img: "https://images.unsplash.com/photo-1744369382892-eb5b6a2fdc6f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-5",
        h: "h-[420px] md:h-[520px]",
    },
    {
        id: "silver",
        title: "Silver",
        desc: "Silver anklets, kadas, payal and auspicious ornaments.",
        img: "https://images.unsplash.com/photo-1632974754836-5aec43c7e3de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-5",
        h: "h-[380px] md:h-[440px]",
    },
    {
        id: "imitation",
        title: "Imitation & Fashion",
        desc: "Bridal imitation, kundan, polki and fashion pieces — for every look.",
        img: "https://images.unsplash.com/photo-1688382654723-a7366006519b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        span: "md:col-span-7",
        h: "h-[380px] md:h-[440px]",
    },
];

export default function Collections() {
    return (
        <section id="collections" data-testid="collections-section" className="py-24 sm:py-32 bg-obsidian-soft border-y border-gold/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <FadeUp>
                        <p className="eyebrow">Heritage Collections</p>
                        <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl mt-4">
                            Every occasion <span className="italic text-gold-gradient">begins with an ornament.</span>
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.15}>
                        <p className="text-muted text-sm max-w-xs leading-relaxed">
                            New and classic designs in every category — you're always welcome to see the full collection.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid md:grid-cols-12 gap-5">
                    {collections.map((c, i) => (
                        <FadeUp key={c.id} delay={i * 0.1} className={c.span}>
                            <article
                                data-testid={`collection-card-${c.id}`}
                                className={`card-frame img-zoom relative overflow-hidden ${c.h} group`}
                            >
                                <img src={c.img} alt={c.title} className="absolute inset-0 w-full h-full object-cover" />
                                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/30 to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                                    <h3 className="font-display text-2xl sm:text-3xl text-ivory group-hover:text-gold-light transition-colors">
                                        {c.title}
                                    </h3>
                                    <p className="text-clay/90 text-sm mt-2 max-w-sm">{c.desc}</p>
                                    <a
                                        href="tel:7209661797"
                                        data-testid={`collection-call-${c.id}`}
                                        className="inline-flex items-center gap-2 mt-5 text-gold-light text-[13px] font-semibold tracking-wide border-b border-gold/40 hover:border-gold-light hover:gap-3 transition-all duration-300"
                                    >
                                        <Phone size={13} />
                                        Call to enquire — 7209661797
                                    </a>
                                </div>
                            </article>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
